export class LoggerData {
  public level: string;
  public labels: string;
  public description: string;
  public title: string;
}

export class LoggerConstants {
  static readonly ClientError = "Console Error";
  static readonly ServerError = "API";
  static readonly ClientTitle = "Error in Typescript - Angular";
  static readonly Fatal = "Fatal";
}